import React from 'react';
import { Submission } from 'types/evaluation';
import TabNavigation from './TabNavigation';
import SubmissionInfoTab from './SubmissionInfoTab';
import PresentationTab from './PresentationTab';
import VideoTab from './VideoTab';

interface MaterialsViewerProps {
  submission: Submission;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  keyPointsExpanded: boolean;
  setKeyPointsExpanded: (expanded: boolean) => void;
  loadingStates: {
    presentation: boolean;
    video: boolean;
  };
  handleIframeLoad: () => void;
  handleVideoLoad: () => void;
}

const MaterialsViewer: React.FC<MaterialsViewerProps> = ({
  submission,
  activeTab,
  setActiveTab,
  keyPointsExpanded,
  setKeyPointsExpanded,
  loadingStates,
  handleIframeLoad,
  handleVideoLoad,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 overflow-hidden">
      {/* Enhanced Tab Navigation */}
      <TabNavigation
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        hasAwardMaterial={!!submission.award_material}
        hasVideoUrl={!!submission.video_url}
      />

      {/* Tab Content */}
      <div className="p-8">
        {/* Submission Information Tab */}
        {activeTab === 'info' && (
          <SubmissionInfoTab
            submission={submission}
            keyPointsExpanded={keyPointsExpanded}
            setKeyPointsExpanded={setKeyPointsExpanded}
          />
        )}

        {/* Presentation Tab */}
        {activeTab === 'presentation' && submission.award_material && (
          <PresentationTab
            awardMaterial={submission.award_material}
            loadingPresentation={loadingStates.presentation}
            handleIframeLoad={handleIframeLoad}
          />
        )}

        {/* Video Tab */}
        {activeTab === 'video' && submission.video_url && (
          <VideoTab
            videoUrl={submission.video_url}
            loadingVideo={loadingStates.video}
            handleVideoLoad={handleVideoLoad}
          />
        )}
      </div>
    </div>
  );
};

export default MaterialsViewer;
